<template>
    <donut-chart :id="id" :data="data" :colors="colors" resize="true"></donut-chart>
</template>
<script>
    import { DonutChart } from 'vue-morris';
    export default {
        props: ['id', 'data', 'colors', 'options'],
        mounted () {
            /*var self = this;
            new Morris.Donut({
                element: self.$el,
                data: this.data,/*[
                    { label: "Abiertas", value: 12 },
                    { label: "Ganadas", value: 30 },
                    { label: "Perdidas", value: 20 }
                ],
                //{this.options},//resize: true,
                colors: this.colors,//['#007bff', '#28a745', '#dc3545'],
            });*/
        },
        components:{
            DonutChart
        }
    }
</script>